/* eslint-disable react/prop-types */
import React from 'react';
import {
  Box, Divider, makeStyles, Typography,
  useTheme,
} from '@material-ui/core';

/**
 * @param {{
 *  className?: string
 *  color?: string
 *  children?: React.ReactNode
 *  title?: string
 *  contentOnly?: boolean
 * }} props
 */

export default function FormCard({
  className, color = '#0093F5', title, children, contentOnly = false,
}) {
  const theme = useTheme();

  const useStyles = makeStyles(() => ({
    root: {
      borderRadius: '16px',
      padding: '32px 40px 38px',
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 30px 70px rgba(58, 53, 104, 0.102)',
      position: 'relative',

      [theme.breakpoints.down('sm')]: {
        padding: '32px 30px 38px',
      },
    },
  }));
  const classes = useStyles();

  return (
    <Box className={`${classes.root} ${className}`}>
      {!contentOnly && (
        <>
          <Typography color={color} style={{ textAlign: 'center', color }}>{title}</Typography>
          <Divider
            style={{
              backgroundColor: color, width: '100%', margin: '27px 0', height: '2px',
            }}
          />
        </>
      )}
      {children}
    </Box>
  );
}
